export default __webpack_public_path__ + "static/media/tiktokExternalTrafficV2.fe37a5c8.svg";